"use client";
import { j as s } from "./jsx-runtime-CJ-St4mQ.mjs";
import { useMemo as m, useCallback as f } from "react";
import { t as c } from "./tv.config-BuYIgndg.mjs";
import { TimelineProvider as b } from "./TimelineContext.js";
const d = c({
  base: [
    "Timeline__root",
    "space-y-8",
    "relative",
    "before:absolute",
    "before:inset-0",
    "before:ml-4",
    "before:-translate-x-px",
    "md:before:mx-auto",
    "md:before:translate-x-0",
    "before:h-full",
    "before:w-px",
    "before:h-[calc(100%-115px)]",
    "before:my-auto",
    "counter-reset"
  ],
  variants: {
    orientation: {
      horizontal: "",
      vertical: ""
    },
    variant: {
      solid: ["before:bg-gray-200"],
      gradient: [
        "before:bg-gradient-to-b",
        "before:from-gray-200",
        "before:via-gray-300",
        "before:to-gray-200"
      ],
      connected: [""]
    }
  },
  defaultVariants: {
    variant: "solid"
  }
}), p = (r) => {
  const { className: o, orientation: e, variant: t, isConnected: i, ...a } = r, n = m(
    () => d({
      orientation: e,
      variant: t,
      className: o
    }),
    [e, t, o]
  );
  return { getTimelineProps: f(
    (l = {}) => ({
      className: n,
      role: "timeline",
      "data-orientation": e,
      isConnected: i,
      variant: t,
      ...a,
      ...l
    }),
    [n, e, t, a]
  ) };
}, T = (r) => {
  const { getTimelineProps: o } = p(r), { variant: e, isConnected: t, ...i } = o();
  return /* @__PURE__ */ s.jsx(b, { variant: e, isConnected: t, children: /* @__PURE__ */ s.jsx("div", { ...i }) });
};
export {
  T as default
};
